import moment from 'moment';

export default {
  name: 'UserPlannedHolidays',

  data () {
    return {
      windowWidth: 2000, // assume non-mobile,
      isMobileWidth: 700, // mobile but also reasonable on desktops
      currentReq: null,
      isLoading: false,
      isUpdating: false,
      months: null,
      weeks: null,
      users: null,
      nextYearGrantedDaysCount: 20, // @TODO get from backend,
      filters: {
        name: null,
        company_id: null,
        department_id: null,
        division_id: null
      },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      showBlock: {
        user: 0,
        month: 0
      },
      year: null,
      yearLastDay: null,
      prevYearLastDay: null,
      managedEntities: []
    }
  },
  computed: {
    isMobile () {
      return this.windowWidth < this.isMobileWidth;
    },
    currentDay () {
      return moment().format('DD.MM.YYYY'); // @TODO return current or end of previous year
    },
    companyOptions () {
      return this.BasicHelper.sortArrayByKeyValue(
        this.$store.getters.getConfigOptions('user_companies', this.$i18n.locale, 'disabled', '0'),
        'text'
      );
    },
    departmentOptions () {
      let departments = this.$store.getters.getConfigOptions(
        'company_departments',
        this.$i18n.locale,
        null, null, false, false, false,
        ['company_id', 'id']
      );
      departments = departments.filter(
        (el) => {
          let result = true;
          if (this.filters?.company_id) {
            result = parseInt(el.company_id) === parseInt(this.filters.company_id);
            if (!result) {
              return false;
            }
          }
          if (this.managedEntities?.departments?.length > 0) {
            result = this.managedEntities?.departments.includes(el.id);
          }
          return result;
        }
      );

      return departments;
    },
    divisionOptions () {
      let divisions = this.$store.getters.getConfigOptions(
        'company_divisions',
        this.$i18n.locale,
        null, null, false, false, false,
        ['department_id', 'id']
      );
      if (this.managedEntities?.departments?.length > 0) {
        divisions = divisions.filter(
          el => this.managedEntities?.departments.includes(parseInt(el.department_id))
        );
      }
      if (this.managedEntities?.divisions?.length > 0) {
        divisions = divisions.filter(
          el => this.managedEntities?.divisions.includes(parseInt(el.id))
        );
      }
      if (this.filters.department_id) {
        divisions = divisions.filter(
          el => parseInt(el.department_id) === parseInt(this.filters.department_id)
        );
      }

      return divisions;
    },
    requestPath () {
      return this.ApiRequest.addGetParamsToPath('planned-holidays/?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.filters);
    },
    isUserHR () {
      return this.ApiRequest.userHasPermission('edit-all-user-planned-holidays');
    },
    isUserManager () {
      return this.ApiRequest.userHasPermission('view-department-user-planned-holidays');
    },
    userId () {
      return this.$session.get('userId');
    },
    headers () {
      return [
        [
          { title: this.$t('planned-holidays.employee'), rowspan: 2 },
          { title: this.$t('planned-holidays.collected-days-current', { currentDay: this.prevYearLastDay }), rowspan: 2 },
          { title: this.$t('planned-holidays.collectable-days-per-year'), rowspan: 2 },
          { title: this.$t('planned-holidays.collected-days-on-last_day', { lastDay: this.yearLastDay }), rowspan: 2 },
          { title: this.$t('planned-holidays.planned-days-current'), rowspan: 2 },
          ...this.months
        ],
        [
          ...this.weeks
        ]
      ]
    }
  },
  methods: {
    changeShowBlock (user, month) {
      this.showBlock = { user: parseInt(user), month: month }
    },
    handleResize () {
      this.windowWidth = window.innerWidth;
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.loadData();
    },
    getRemainingDaysCount (remainHoliday, userId, returnHtml = true) {
      const amount = Math.round((remainHoliday + this.nextYearGrantedDaysCount - this.users[userId].planned_holidays_count) * 100) / 100;
      const cssClass = amount > 10 ? 'text-danger font-weight-bold' : null;
      return returnHtml ? `<span class="${cssClass}">${amount}</span>` : amount;
    },
    // didnt use NumberInput in order to have custom validations
    updateCount (event, oldValue, weekId, userApiId, userId) {
      const newValue = event.data;
      const parsedNewValue = parseInt(event.data)
      if (!oldValue) {
        oldValue = '';
      }
      if (oldValue == newValue) {
        return;
      }
      if ((parsedNewValue && (parsedNewValue > 5 || parsedNewValue < 0)) || (isNaN(parsedNewValue) && newValue)) {
        this.users[userId].all_planned_holidays[weekId] = oldValue;
        this.$forceUpdate();
        return;
      }
      this.users[userId].all_planned_holidays[weekId] = parsedNewValue;
      this.$forceUpdate();
      const data = {
        week_id: weekId,
        days: parsedNewValue
      }
      if (this.isUserHR) {
        data.user_api_id = userApiId;
      }
      this.isUpdating = true;
      this.ApiRequest.request('planned-holidays', this.ApiRequest.REQUEST_PATCH, data, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else if (response.data) {
          this.users[userId].planned_holidays_count = response.data.planned_holidays_count;
          let message = this.$t('planned-holidays.collected-days-on-last_day', { lastDay: this.yearLastDay });
          message = message + ': ' + this.getRemainingDaysCount(this.users[userId].job_positions[0].remain_holiday, userId, false);
          this.$store.commit('toastAdd', { context: 'success', message: message });
          this.$forceUpdate();
        }
        this.isUpdating = false;
      });
    },
    loadData () {
      // general.datestr.ismonth.1
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.isLoading = true;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else if (response.data) {
          this.weeks = response.data.weeks;
          this.months = response.data.months;
          this.users = response.data.users;
          this.paging = response.paging;
          this.year = response.data.active_year;
          this.yearLastDay = response.data.active_year_last_date;
          this.prevYearLastDay = response.data.prev_year_last_date;
          this.managedEntities = response.data.managed_entities;
        }
        this.isLoading = false;
      });
    }
  },
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler (val) {
        if (this.currentReq) {
          this.currentReq.cancel('changed search query');
        }
        this.paging.page = 1;
        this.loadData();
      }
    }
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted () {
    this.windowWidth = window.innerWidth;
    if (window.innerWidth < this.isMobileWidth) {
      this.paging.limit = 1;
    }
    window.addEventListener('resize', this.handleResize);
    this.loadData();
  }
}
